<template>
  <div class="addPackageWrapper">
    <q-form @submit="onSubmit" class="form">
      <CustomCheckbox label="По умолчанию" :value="this.formData.is_default"
        @change="(value) => onChange('is_default', value)" />
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "add-project-entry",
  components: { CustomCheckbox, CustomModalFooter },
  props: ["data"],
  data() {
    return {
      loading: false,
      formData: {
        placement_type_id: this.data?.body?.placement_type_id || "",
        work_set_id: this.data?.body?.work_set_id || "",
        material_set_id: this.data?.body?.material_set_id || "",
        is_default: this.data?.body?.is_default !== undefined
          ? this.data.body.is_default
          : true,
        preset_kit_id: this.data?.body?.preset_kit_id || null,
      },
    };
  },
  methods: {
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 700px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
